import LogoMark from "./LogoMark";

/**
 * Waiting state for backend round-trips: the B-mark charging up.
 *
 * Two stacked copies of the logo — a faint one holding the silhouette, and an
 * accent one revealed bottom-up by a rising clip — so the mark itself is the
 * progress indicator rather than a generic ring beside it. Deliberately calm
 * (Nordisk Ro): one slow fill, one soft glow, no bouncing.
 *
 * The fill is indeterminate on purpose — it never reaches 100 %, so it can't
 * promise a completion it doesn't know about.
 */
export default function ChargeSpinner({ label, className = "" }: { label: string; className?: string }) {
  return (
    <div className={`flex flex-col items-center gap-4 ${className}`} role="status">
      <div className="relative isolate grid h-[72px] w-[78px] place-items-center">
        <span aria-hidden="true" className="charge-glow" />
        <LogoMark className="absolute inset-0 h-full w-full text-line-strong" />
        <span aria-hidden="true" className="charge-fill absolute inset-0">
          <LogoMark className="h-full w-full text-accent" />
        </span>
      </div>
      <p className="charge-label max-w-[28ch] text-center font-mono text-[12px] leading-relaxed text-ink-faint">
        {label}
      </p>
    </div>
  );
}
